import React from 'react';

import { ShippingServiceLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

export const Service = () => {
  const { service } = useFulfillmentDisplayContext();
  return <ReadonlyField label={ShippingServiceLabel}>{service}</ReadonlyField>;
};
